<template>
  <div class="collection-breadcrumbs">
    <a class="body-sm" href="/">Home</a>
    <span class="collection-breadcrumbs__divider body-sm">/</span>
    <span class="body-sm">{{ collectionTitle }}</span>
  </div>
</template>

<script>
export default {
  name: 'CollectionBreadcrumbsB',
  props: {
    collectionHandle: {
      type: String,
      required: true,
    },
    collectionTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-breadcrumbs {
  padding: 8px 0;
  line-height: 20px;
  margin-bottom: 32px;

  @include mobile-tablet {
    display: none;
  }

  &__divider {
    margin: 0 6px;
  }

  a {
    color: $color-dark-grey;
    text-decoration: none;
  }

  span {
    color: $color-black;
    font-weight: 500;
    user-select: none;
  }
}
</style>
